// Frontend/geniac/src/Components/Settings/StatusBannerWrapper.tsx
// Wrapper qui affiche automatiquement la bannière de statut selon l'état de l'organisation

import React from 'react';
import { StatusBanner } from './StatusBanner';
import { useOrganizationStatus } from '../../hooks/useOrganizationStatus';

export const StatusBannerWrapper: React.FC = () => {
  const { organization, subscription, loading } = useOrganizationStatus();

  // Debug logs
  console.log('🔍 StatusBannerWrapper - organization:', organization);
  console.log('🔍 StatusBannerWrapper - subscription:', subscription);

  // Ne rien afficher pendant le chargement
  if (loading || !organization) {
    return null;
  }

  // Normaliser le statut (accepter OVER_QUOTA, over_quota, etc.)
  const normalizedStatus = organization.status?.toUpperCase().replace(/-/g, '_');

  // Message D - Bannière OVER_QUOTA
  if (normalizedStatus === 'OVER_QUOTA') {
    // Construire le tableau overages à partir de over_quota_details
    const details = organization.over_quota_details;
    const overages: Array<{ resource: string; current: number; limit: number }> = [];

    if (details?.projects_over && details.projects_over > 0) {
      overages.push({
        resource: 'projects',
        current: details.projects_current || 0,
        limit: details.projects_limit || 0
      });
    }
    if (details?.architectures_over && details.architectures_over > 0) {
      overages.push({
        resource: 'architectures',
        current: details.architectures_current || 0,
        limit: details.architectures_limit || 0
      });
    }

    console.log('🔍 StatusBannerWrapper - overages:', overages);

    return (
      <StatusBanner
        type="over-quota"
        data={{
          current_plan: subscription?.plan || 'free',
          overages: overages
        }}
      />
    );
  }

  // Message E - Bannière READ_ONLY (SUSPENDED ou CANCELLED)
  if (normalizedStatus === 'SUSPENDED' || normalizedStatus === 'CANCELLED') {
    return <StatusBanner type="read-only" />;
  }

  // Message pour TRIAL_EXPIRED
  if (normalizedStatus === 'TRIAL_EXPIRED') {
    return <StatusBanner type="trial-expired" />;
  }

  // Message C - Bannière downgrade programmé
  if (subscription?.downgrade_effective_at) {
    return (
      <StatusBanner
        type="downgrade-scheduled"
        data={{
          target_plan: subscription.pending_plan || 'free',
          effective_date: new Date(subscription.downgrade_effective_at).toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })
        }}
      />
    );
  }

  // Pas de bannière à afficher
  return null;
};

export default StatusBannerWrapper;
